import { Card, Divider } from "@mui/material";
import { useState } from "react";
import Scrollbar from "src/components/Scrollbar";
import DataHandlerTable from "src/components/data-handler/table";
import Map from "src/components/map";
import PaginationButtons from "src/components/pagination";
import TableMenu from "src/components/tableMenu";
import Ternary from "src/components/ternary";
import Actions from "./actions";
import StatusdDialog from "./StatusDialog";
import { isMenuActive } from "src/utils/actionProtector";
import useConsultation from "./hooks/useConsultation";
import DataFilter from "./dataFilter";
import DataList from "./dataList";
import useFilter from "./hooks/useFilter";

const headers = [
  "consultation.no",
  "consultation.name",
  "consultation.username",
  "consultation.mobile",
  "consultation.sponsor",
  "consultation.package_name",
  "consultation.purchasedAt",
  "consultation.status",
  "consultation.action",
];

const genStatus = (gp, p) => {
  const test = isMenuActive(gp, p);
  return {
    add: test("add"),
  };
};

const DataTable = () => {
  // const methods = useForm({ defaultValues, resolver: yupResolver(schema) });
  const methods = useFilter();
  const filter = methods.watch();
  const { state, fetchConsultationList, page, dataList, rowStart, ...rest } =
    useConsultation(filter);
  const { data, ...dataProps } = state;
  const [openMenu, setOpenMenuActions] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [status, setStatus] = useState(null);

  const [openStatus, setOpenStatus] = useState(false);

  const handleOpenMenu = (id, status) => (event) => {
    setOpenMenuActions(event.currentTarget);
    setSelectedId(id);
    setStatus(status);
  };
  const handleCloseMenu = () => {
    setOpenMenuActions(null);
  };

  const OpenChangeStatus = () => {
    setOpenStatus(true);
    handleCloseMenu();
  };

  const CloseChangeStatus = () => {
    setOpenStatus(false);
  };
  const onFilter = methods.handleSubmit((inputData) => {
    fetchConsultationList(1, inputData);
  });
  return (
    <>
      <Card>
        <DataFilter methods={methods} onFilter={onFilter} />
        <Scrollbar>
          <DataHandlerTable
            name="network-table"
            headers={headers}
            dataProps={{ ...dataProps }}
          >
            <Map
              list={data}
              render={(consultation, i) => (
                <DataList
                  handleOpenMenu={handleOpenMenu}
                  consultation={consultation}
                  rowNumber={rowStart + i}
                />
              )}
            />
          </DataHandlerTable>
        </Scrollbar>

        <Divider />
      </Card>

      <TableMenu onClose={handleCloseMenu} open={openMenu}>
        <Actions
          selectedId={selectedId}
          dataList={dataList}
          OpenChangeStatus={OpenChangeStatus}
          CloseChangeStatus={CloseChangeStatus}
        />
      </TableMenu>

      <StatusdDialog
        page={page}
        filter={filter}
        open={openStatus}
        selectedId={selectedId}
        status={status}
        onClose={CloseChangeStatus}
        fetchData={fetchConsultationList}
      />

      <Ternary
        when={!dataProps.isArrayEmpty}
        then={<PaginationButtons page={page} {...rest} />}
      />
    </>
  );
};

export default DataTable;
